<div class="g-layout__container">
    @if (strategyOptions.length) {

    <div>
        <div class=" flex justify-content-between align-items-center">
            <div class="flex align-items-center">
                <p-dropdown ngClass="drop" (onChange)="strategyOptionsChange()" [(ngModel)]="selectedStrategyId"
                    [options]="strategyOptions" optionLabel="name" optionValue="strategyId"
                    placeholder=" {{'select strategy'|translate}}" />
            </div>

            @if(!user.section_employee)
            {

            <p-button [routerLink]="['/createStrategy',selectedStrategyId]" label="{{'edit' | translate}}"
                [outlined]="true"></p-button>
            }
        </div>
        <div class="br"></div>
    </div>
    }
    @if (strategyOptions.length) {

    <div>
        <div class="grid pt-4">
            <div class="lg:col-6 md:col-12 sm:col-12">
                <div class="flex align-items-center">
                    <div class="flex align-items-center">
                        <i class="fa-solid fa-eye text-2xl g-c-primary"></i>

                    </div>
                    <p class="mx-2 font-bold text-2xl g-c-primary-darker">
                        {{'our vision'|translate}}
                    </p>

                </div>
                <p class="line-height-4">
                    {{targetStrategy.vision}}
                </p>
            </div>
            <div class="lg:col-6 md:col-12 sm:col-12">
                <div class="flex">
                    <div class="flex align-items-center">
                        <i class="fa-solid fa-comment text-2xl g-c-primary"></i>


                    </div>
                    <p class="mx-2 font-bold  text-2xl g-c-primary-darker">
                        {{'our mission'|translate}}
                    </p>

                </div>
                <p class="line-height-4">
                    {{targetStrategy.mission}}
                </p>
            </div>
        </div>
    </div>
    <div class="g-bg-secondary-color  justify-content-center p-5   grid border-round-xl my-4 ">
        <a [routerLink]="['/strategies/goals']" class="lg:col-3 md:col-6 col-12">
            <div class="flex justify-content-center hover  px-2  g-c-primary-dark-color align-items-center border-round-xl border-1"
                style="border-color:var(--primary-color)">
                <i class="fa-solid fa-bullseye text-xl g-c-primary"></i>
                <p class="mx-2 font-bold">
                    {{"view_goals_action"|translate}}
                </p>

            </div>
        </a>
        <a [routerLink]="['/strategies/indicators']" class="lg:col-3 md:col-6 col-12">
            <div class="flex  justify-content-center   hover   px-2 g-c-primary-dark-color align-items-center border-round-xl border-1"
                style="border-color:var(--primary-color)">
                <i class="fa-solid fa-chart-column text-xl g-c-primary"></i>

                <p class="mx-2 font-bold">
                    {{"view_indicators_action"|translate}}
                </p>

            </div>

        </a>
        <a [routerLink]="['/strategies/projects']" class="lg:col-3 md:col-6 col-12">
            <div class="flex px-2 g-c-primary-dark-color  hover justify-content-center align-items-center border-round-xl border-1"
                style="border-color:var(--primary-color)">
                <i class="fa-solid fa-sliders text-xl g-c-primary"></i>
                <p class="mx-2 font-bold">
                    {{"view_initiatives_action"|translate}}
                </p>

            </div>

        </a>
    </div>
    <div class="mb-5">
        <app-values class="rounded" [values]="targetStrategy.values"></app-values>
    </div>
    }@else {
    <app-strategy404></app-strategy404>
    }
</div>